export default "__VITE_ASSET__CyZ4VRK0__"